// Converts Arabic numeral digits (0-9) inside a string/number to Devanagari
// numerals (०-९), leaving every other character (commas, slashes, decimal
// points, letters) untouched. Single-purpose module, separate from any
// number-to-words conversion, which spells numbers out rather than just
// swapping the digit glyphs.

const DEVANAGARI_DIGITS = ["०", "१", "२", "३", "४", "५", "६", "७", "८", "९"];

export function toDevanagariNumerals(value: unknown): string {
  return String(value ?? "").replace(/[0-9]/g, (digit) => DEVANAGARI_DIGITS[Number(digit)]);
}
